import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../auth/service/utils.service";

@Component({
  selector: "app-pdf-viewer",
  template: ``,
  styles: [""]
})
export class PdfViewerComponent implements OnInit {

  constructor(private _utils: UtilsService) {
  }

  async ngOnInit() {
    this._utils.AttachmentViewerURL.subscribe((url: string) => {
      const viewer: any = document.querySelector("#pdf-viewer");
      const iframe = viewer.querySelector("#pdf");
      this._utils.showLoading();
      if (url.length > 0) {
        iframe.src = url;
        const fileName = this._utils.AttachmentViewerFileName.value;
        // Aggiungi un evento onload all'iframe
        iframe.onload = function() {
          if (!fileName.includes(".pdf")) {
            const firstElement = iframe.contentWindow.document.querySelector("body > *:first-child");
            if (firstElement.width < window.innerWidth - 40) {
              iframe.style.width = firstElement.width + "px";
            }
            if (firstElement.height < window.innerHeight - 40) {
              iframe.style.height = firstElement.height + "px";
            } else {
              iframe.style.minHeight = "90vh";
            }
          } else {
            // Ottieni le dimensioni del contenuto dell'iframe
            let iframeContentHeight = iframe.contentWindow.document.body.scrollHeight;
            iframeContentHeight = window.innerHeight > iframeContentHeight ? window.innerHeight - 40 : iframeContentHeight;
            // Imposta l'altezza e la larghezza dell'iframe in base al contenuto
            iframe.style.height = iframeContentHeight + "px";
            iframe.style.minHeight = '90vh'
          }
        };
        viewer.classList.remove("d-none");
      } else {
        iframe.src = "";
        viewer.classList.add("d-none");
      }
      this._utils.hideLoading();
    });

    const closeBtn: any = document.querySelector("#pdf-viewer #closeButton");
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        this._utils.AttachmentViewerURL.next("");
        this._utils.AttachmentViewerFileName.next("");
        window.history.back()
      });
    }
  }

}
